'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _createChart = require('./create-chart');

var _createChart2 = _interopRequireDefault(_createChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_TYPES = (0, _immutable.fromJS)([{
  value: 'G',
  label: 'Grades',
  hasLevels: true,
  levelsLabel: 'Level',
  events: []
}, {
  value: 'C',
  label: 'Championships',
  hasLevels: false,
  events: []
}, {
  value: 'F',
  label: 'Figures',
  hasLevels: false,
  events: []
}, {
  value: 'S',
  label: 'Specials',
  hasLevels: true,
  levelsLabel: 'Category',
  events: []
}]);

exports.default = function (feis) {
  return function (state) {
    var feis_id = feis.get('id');
    var eventsPath = ['feiseanna', 'events', feis_id];
    var types = EVENT_TYPES;

    var metadata = state.getIn(eventsPath) || (0, _immutable.Map)();
    var events = metadata.get('all') || (0, _immutable.List)();

    // Store the list of event names so we check it later to ensure uniqueness.
    var eventNames = events.map(function (ev) {
      return ev.get('name');
    });

    // There is nothing to do if there are no events.
    if (events.count() === 0) {
      return {
        events: metadata,
        eventNames: eventNames,
        types: types
      };
    }

    // Add events to each type list.
    events.forEach(function (ev) {
      types = types.map(function (type) {
        if (type.get('value') === ev.get('type')) {
          return type.set('events', type.get('events').push(ev));
        }

        return type;
      });
    });

    types = types.map(function (type) {
      var charts = (0, _immutable.List)();

      if (type.get('hasLevels')) {
        // Create a temporary map of levels to chart objects, so we can have one chart for every
        // level with all events matching that level.
        var byLevel = {};
        type.get('events').forEach(function (event) {
          var level = event.get('level');

          if (!byLevel[level]) {
            byLevel[level] = {
              level: level,
              label: level,
              events: []
            };
          }

          byLevel[level].events.push(event);
        });

        // Serialize the map of levels->charts into an immutable list of charts.
        charts = (0, _immutable.fromJS)(Object.getOwnPropertyNames(byLevel).map(function (k) {
          return byLevel[k];
        }));
      } else {
        charts = charts.push((0, _immutable.Map)({
          level: false,
          label: 'All ' + type.get('label'),
          events: type.get('events')
        }));
      }

      // Sort charts by label alphabetically.
      charts = charts.sort(function (a, b) {
        return a.get('label').localeCompare(b.get('label'));
      });

      // TODO: re-calc chart only if changed using memoized selectors
      // TODO: only calc charts for currently viewed type instead of all types
      // TODO: skip empty charts (is this even possible?)
      charts = charts.map(function (chart) {
        return (0, _createChart2.default)(chart.get('level'), chart.get('label'), chart.get('events'));
      });

      return type.set('charts', charts);
    });

    var eventLevels = state.getIn(['feiseanna', 'one', 'eventLevels', feis_id]) || (0, _immutable.Map)();
    var eventTypes = state.getIn(['feiseanna', 'one', 'eventTypes', feis_id]) || (0, _immutable.Map)();

    return {
      events: events,
      eventNames: eventNames,
      types: types,
      eventLevels: eventLevels,
      eventTypes: eventTypes
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/syllabus/mapStateToController.js
// module id = 577
// module chunks = 0